import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import { useCallCenterDevices } from "../../../providers/callCenterDevice";
import { hasActiveFilter } from "../utils";
import FilterButton from "../../../molecules/FilterButton";
import Button from "../../../atoms/Button";
const CallCenterDeviceDesktopFilter = () => {
    const { filterChoices, onFilterChange } = useCallCenterDevices();
    const { t } = useTranslation();
    const handleFilterChange = (key) => (selected) => {
        onFilterChange(key, selected);
    };
    const handleResetPress = () => {
        onFilterChange("deviceTypes", []);
        onFilterChange("metricTypes", []);
        onFilterChange("statuses", []);
        onFilterChange("connectionStatuses", []);
        onFilterChange("ownerships", []);
    };
    if (!filterChoices) {
        return null;
    }
    return (_jsxs(HStack, Object.assign({ space: "2", mr: "auto" }, { children: [_jsx(FilterButton, { isSearchable: true, title: t("device"), items: filterChoices.deviceTypes, onChange: handleFilterChange("deviceTypes"), isMultiselect: true }), _jsx(FilterButton, { isSearchable: true, title: t("measures:type"), items: filterChoices.metricTypes, onChange: handleFilterChange("metricTypes"), isMultiselect: true }), _jsx(FilterButton, { title: t("logistics"), items: filterChoices.statuses, onChange: handleFilterChange("statuses"), isMultiselect: true }), _jsx(FilterButton, { title: t("state"), items: filterChoices.connectionStatuses, onChange: handleFilterChange("connectionStatuses"), isMultiselect: true }), _jsx(FilterButton, { title: t("settlement"), items: filterChoices.ownerships, onChange: handleFilterChange("ownerships"), isMultiselect: true }), hasActiveFilter(filterChoices) ? (_jsx(Button, Object.assign({ onPress: handleResetPress, size: "xs", variant: "link" }, { children: t("setback") }))) : null] })));
};
export default CallCenterDeviceDesktopFilter;
